import { APPCONFIG } from './app.config';

const BASE_URL = APPCONFIG.baseUrl;
const API_VERSION = APPCONFIG.apiVersion;
const APP_NAME = APPCONFIG.appName;

export type IAPICONFIG = {
	[key: string]: string;
};

export const APICONFIG: IAPICONFIG = {
	PROFILE_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/user-profile/me/`,
	BANNER_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/dashboard-banners`,
	MEETNG_API: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/dashboard-meetings/?page=1&limit=10`,
	QUARTER_SUMMARY_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/dashboard-quarter-summary/`,
	COMPETITION_CONVERSION_USAGE: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/reason-for-competition`,
	COMPETITION_CONVERSION_GRADE: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/grade`,
	COMPETITION_CONVERSION_PRODUCT_RECOMMENDED: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/competition-conversion`,
	BASIC_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/lead-user/`,
	EDIT_BASIC_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/account/`,
	TOWN_LIST_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/town/`,
	IMR_CODE_LIST_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/imr-code/`,
	ADOPTED_CONTRACTOR_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/adopted-contractors/`,
	LEAD_USER_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/lead-user/`,
	ALL_END_USER_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/all-end-user/`,
	CLUB_DROPDOWN: `${BASE_URL}${API_VERSION}/${APP_NAME}/club-dropdown/`,
	DEALERS_LIST: `${BASE_URL}${API_VERSION}/${APP_NAME}/dealer/`,
	ADOPTED_CONTRACTOR_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/adopted-contractors`,
	ALL_ENDUSER_CONTRACTOR_DETAILS: `${BASE_URL}${API_VERSION}/${APP_NAME}/all-end-user`,
	SITE_LEAD: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/site-lead/`,
	ALL_CALENDAR_DETAILS: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/calendar`,
	TASKLIST_PRODUCTS: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/product-recommendations`,
	SITE_VISIT: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/visit/`,
	ALL_SITE_SUMMARY_LIST: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/site-summary/`,
	AVAILABLE_PRODUCTS_LIST: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/products/`,
	CLOSE_LEADS: `${BASE_URL}${API_VERSION}/${APP_NAME}/closelead`,
	PHONE_NUMBER: `${BASE_URL}${API_VERSION}/${APP_NAME}/validate_phone`,
	GLUE_POTENTIAL: `${BASE_URL}${API_VERSION}/${APP_NAME}/gluepotential`,
	ALL_EVENT_DETAILS: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/events`,
	VISIT_FEEDBACK: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/visit-feedback/`,
	IMAGE_GALLERY: `${BASE_URL}/apis/v.1.0/fv/image`,
	USER_LIST: `${BASE_URL}${API_VERSION}/${APP_NAME}/pidilite-user`,
	PRESIGNED_URL: `${BASE_URL}${API_VERSION}/common/${APP_NAME}/get-pre-signed-url/`,
	SITE_SUMMARY_LISTING: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/site-summary/`,
	REDEMPTION_HISTORY: `${BASE_URL}/apis/v.1.0/capillary/get-banking-history/`,
	MEETINGS_DETAILS: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/meetings`,
	VIDEO_GALLERY: `${BASE_URL}${API_VERSION}/gallery/wwa/video`,
	CALCULATOR_PRODUCT_LIST: `${BASE_URL}/apis/v.1.0/calculator/`,
	CURRENT_SLAB: `${BASE_URL}${API_VERSION}/wwa/slab-claculator`,
	CUSTOMER_HISTORY: `${BASE_URL}/apis/v.1.0/capillary/get-customer`,
	VALIDATE_BARCODE: `${BASE_URL}/apis/v.1.0/capillary/barcode-scan`,
	POINTS_DASHBOARD: `${BASE_URL}/apis/v.1.0/capillary/get-customer-lookup`,
	BANKING_DETAIL: `${BASE_URL}${API_VERSION}/wwa/banking-data`,
	END_USER_NORMS_COUNT: `${BASE_URL}/apis/v.2.0/common/fv/enroll-user-count`,
	END_USER_NORMS: `${BASE_URL}/apis/v.2.0/common/fv/end-user-norm/`,
	CLUB_MEMBER_LIST: `${BASE_URL}/apis/v.2.0/common/fv/club-member-list`,
	NON_REPEAT_ATTENDED: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/non-repeat-attendee/`,
	MEETING_TYPE: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/meeting-type/`,
	PRODUCT_USAGE: `${BASE_URL}${API_VERSION}/wwa/product-usage/`,
	GET_CONTRACTOR_REDEMPTION_HISTORY: `${BASE_URL}${API_VERSION}/wwa/contractor-redemption-history/`,
	ADD_SITE_STATUS: `${BASE_URL}${API_VERSION}/site-leads/wwa/site-status/`,
	SITE_LEAD_OVERVIEW: `${BASE_URL}/apis/v.3.0/site-leads/wwa/site-summary/`,
	DEALER_VISITS: `${BASE_URL}/apis/v.3.0/dealer-visit/wwa/crud/`,
	DEALER_VISIT_PRODUCTS: `${BASE_URL}/apis/v.3.0/dealer-visit/wwa/product/`,
	FPC_DETAILS: `${BASE_URL}/apis/v.3.0/site-leads/wwa/fpc-tier-status/`,
	CLUB_RECOMMENDATION: `${BASE_URL}${API_VERSION}/meetings/wwa/club-recommendation/`,
	MEMBER_NAME_DETAILS: ` ${BASE_URL}${API_VERSION}/dealer-visit/wwa/get-member-name/`,
	SITE_LEAD_DETAILS: ` ${BASE_URL}/apis/v.3.0/site-leads/wwa/site-lead-detail/`,
	SCHEME_DETAILS: `${BASE_URL}${API_VERSION}/common/wwa/scheme`,
	LOGIN: `${BASE_URL}/apis/v.1.0/login`,
	UPDATE_SITE_LEAD: `${BASE_URL}${API_VERSION}/site-leads/wwa/site-lead/`,
	GET_MEMBERSHIP_NUMBER: `${BASE_URL}/apis/v.1.0/capillary/get-membershipno`,
	ONE_TO_ONE_MEETINGS_LIST: `${BASE_URL}${API_VERSION}/meetings/wwa/one-to-one-meetings`,
	LOGOUT: `${BASE_URL}${API_VERSION}/common/wwa/logout/`,
	END_USER_LIST: `${BASE_URL}${API_VERSION}/meetings/wwa/end-user-list/`,
	WSS_TERRITORY_LIST: `${BASE_URL}${API_VERSION}/meetings/wwa/wss-territory/`,
	PRIMARY_DEALERS_LIST: `${BASE_URL}${API_VERSION}/meetings/wwa/dealer-details-list/`,
	ADD_QUICK_ENDUSER: `${BASE_URL}${API_VERSION}/meetings/wwa/quick-end-user/`,
	END_USER_CATEGORY_LIST: `${BASE_URL}${API_VERSION}/meetings/wwa/end-user-category/`,
	FM_CONTENT: `${BASE_URL}${API_VERSION}/wwa/fm-media-content/`,
	BIRTHDAY_POP_UP: `${BASE_URL}/apis/v.3.0/common/wwa/birthday/`,
	TSI_IMAGE_UPLOAD: `${BASE_URL}${API_VERSION}/dealer-visit/wwa/tsi-image-upload/`,
	BDE_OF_IMR: `${BASE_URL}${API_VERSION}/wwa/bde-of-imr/`,
	FOCUS_PRODUCT: `${BASE_URL}${API_VERSION}/wwa/focus-product/`,
	END_USER_ELIGIBLE_FOR_VISIT: `${BASE_URL}${API_VERSION}/wwa/end-user-eligible-for-visit/`,
	CHECK_BDE_LEAVE: `${BASE_URL}${API_VERSION}/wwa/bde-on-leave/`,
	GET_SITE_VISIT_OTP: `${BASE_URL}/apis/v.2.0/common/site-visit-otp-verification/send-otp/`,
	VERIFY_SITE_OTP: `${BASE_URL}/apis/v.2.0/common/site-visit-otp-verification/verify-otp/`,
	SUPERVISOR_LIST_BY_CONTACT: `${BASE_URL}${API_VERSION}/wwa/supervisor-contractor/`,
	SUPERVISOR_ADD_UPDATE: `${BASE_URL}${API_VERSION}/wwa/supervisor/`,
	SUPERVISOR_BANKING_HISTORY: `${BASE_URL}${API_VERSION}/wwa/supervisor-banking-history/`,
	FACTORY_VISIT_LIST: `${BASE_URL}${API_VERSION}/site-leads/wwa/factory-visit/`,
	GET_KAE_STATUS: `${BASE_URL}${API_VERSION}/site-leads/wwa/get-kae-product-recommendation/`,
	GET_PRODUCT_RECOMMENDATION_LIST: `${BASE_URL}${API_VERSION}/site-leads/wwa/kae-product-recommendation/`,
	ADD_PRODUCT_RECOMMENDATION: `${BASE_URL}${API_VERSION}/site-leads/wwa/kae-product-recommendation/`,
	GET_CONTRACTORS_FPC_LIST: `${BASE_URL}${API_VERSION}/wwa/sub-contractor-list/`,
	ADD_SUBCONTRACTORS_DETAIL: `${BASE_URL}${API_VERSION}/wwa/sub-contractor-tagging/`,
	FCC_CHECKS_FPC_USER: `${BASE_URL}/apis/v.3.0/wwa/fcc-checks-fpc-user/`,
	FCC_USER_SLAB: `${BASE_URL}/apis/v.3.0/wwa/fcc-fpc-users-slab/`,
	FCC_ENROLL: `${BASE_URL}/apis/v.3.0/wwa/fcc-enroll-fpc-user/`,
	MEETINGS_MARK_ATTENDANCE: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/meetings/`,
	GET_JHAROKHA_TOKEN: `${BASE_URL}/apis/v.2.0/common/jharokha-token-generate/`,
	GET_END_USER_OTP: `${BASE_URL}/apis/v.3.0/wwa/lead-otp/`,
	VERIFY_END_USER_OTP: `${BASE_URL}/apis/v.3.0/wwa/lead-otp/`,
	PCMS_TOKEN: `${BASE_URL}/apis/v.2.0/pcms/mpower-token/`,
	SITE_SPECIALIST_LIST: `${BASE_URL}${API_VERSION}/site-leads/wwa/site-specialist-dropdown/`,
	ADD_MICRO_SITE: `${BASE_URL}${API_VERSION}/site-leads/wwa/site-specialist-visit-feedback/`,
	ADD_SITE_SS: `${BASE_URL}${API_VERSION}/site-leads/wwa/site-lead/`,
	KAESS_PRODUCT_LIST: `${BASE_URL}${API_VERSION}/site-leads/wwa/kae-ss-visit-products/`,
	KAESS_VISIT_CREATE: `${BASE_URL}${API_VERSION}/site-leads/wwa/kae-ss-visit/`,
	AVAILABLE_OTHER_PRODUCTS_LIST: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/other-products/`,
	PRODUCT_RECOMMENDATION_LIST_KAE: `${BASE_URL}${API_VERSION}/site-leads/wwa/get-product-recommendation/`,
	PRODUCT_COMMENT_UPDATE_KAE: `${BASE_URL}${API_VERSION}/site-leads/wwa/update-product-comment/`,
	C_AID: `${BASE_URL}${API_VERSION}/${APP_NAME}/contractor-aid/`,
	JHAROKHA_PRODUCT: `${BASE_URL}/apis/v.2.0/common/jharokha-product-details/`,
	CLUSTER_LIST_API: `${BASE_URL}${API_VERSION}/${APP_NAME}/cluster-list/`,
	IMAGE_FETCH_API: `${BASE_URL}/apis/v.1.0/mpower/azure-sas-token/`,
	PRESIGNED_URL_DELETE: `${BASE_URL}${API_VERSION}/common/${APP_NAME}/delete-blob/`,
	QUARTER_SUMMARY_API_RBDM: `${BASE_URL}${API_VERSION}/${APP_NAME}/rbdm-dashboard-quartersummary/`,
	ALL_END_USER_API_RBDM: `${BASE_URL}${API_VERSION}/${APP_NAME}/rbdm-all-end-user`,
	CMDI_DROPDOWN_RBDM: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/rbdm-cmdi-dropdown`,
	SUPERVISOR_LIST_RBDM: `${BASE_URL}${API_VERSION}/wwa/rbdm-supervisor-contract/`,
	MEETINGS_DETAILS_RBDM: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/rbdm-meet-list`,
	MEETINGS_DETAILS_RBDM_ADD: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/rbdm-create-meeting`,
	RBDM_CLUB_DROPDOWN: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/rbdm-club-dropdown`,
	PRODUCT_PERFORMANCE: `${BASE_URL}${API_VERSION}/common/wwa/rbdm-product-performance/`,
	RBDM_BUDGET_ALLOCATED: `${BASE_URL}${API_VERSION}/meetings/wwa/rbdm-budget/`,
	RBDM_MEET_COMPARE: `${BASE_URL}${API_VERSION}/meetings/wwa/rbdm-meet-compare/`,
	END_USER_NORMS_COUNT_RBDM: `${BASE_URL}${API_VERSION}/common/wwa/rbdm-enroll-user-counts/`,
	END_USER_NORMS_RBDM: `${BASE_URL}${API_VERSION}/common/wwa/rbdm-end-user-norms/`,
	SS_CONTRACTOR: `${BASE_URL}${API_VERSION}/wwa/lms-contractor/`,
	LMS_DASHBOARD_SUMMARY_API: `${BASE_URL}${API_VERSION}/wwa/lms-dashboard-summary/`,
	LMS_SS_DASHBOARD_SUMMARY_API: `${BASE_URL}${API_VERSION}/members/wwa/lms-ss-dashboard-summary/`,
	LMS_SITE_ADD_OR_LIST_API: `${BASE_URL}${API_VERSION}/site-leads/wwa/lms-site-lead/`,
	LMS_CONTRACTOR: `${BASE_URL}${API_VERSION}/wwa/lms-contractor/`,
	LMS_PRODUCT_RECOMMENDATIONS: `${BASE_URL}${API_VERSION}/site-leads/wwa/lms-product-recommendation/`,
	LMS_LEADS_LISTING_SITE: `${BASE_URL}${API_VERSION}/wwa/lms-leads-listing/`,
	LMS_SS_LIST: `${BASE_URL}${API_VERSION}/common/wwa/ss-dropdown/`,
	LMS_LEADS_LISTING: `${BASE_URL}${API_VERSION}/wwa/lms-leads-listing/`,
	LMS_SITE_VISITS: `${BASE_URL}${API_VERSION}/site-leads/wwa/lms-revisit`,
	LMS_CONTRACTOR_SITE_SUMMARY: `${BASE_URL}${API_VERSION}/site-leads/wwa/lms-site-summary/`,
	CLUB_MEMBER_LIST_RBDM: `${BASE_URL}${API_VERSION}/common/wwa/rbdm-club-member-list/`,
	TOWN_LIST_DETAILS_RBDM: `${BASE_URL}${API_VERSION}/meetings/wwa/rbdm-town-list/`,
	ENABLE_CARPENETER_OPTIONS: `${BASE_URL}${API_VERSION}/wwa/account/`,
	SITE_VISIT_ACTIVE_URL: `${BASE_URL}/apis/v.3.0/site-leads/wwa/site-visit-active-url/`,
	MEETING_MEDIA_URL: `${BASE_URL}${API_VERSION}/meetings/wwa/meeting-media/`,
	USER_TRANSFER_FNB: `${BASE_URL}${API_VERSION}/wwa/account/`,
	FNB_BANKING_HISOTRY: `${BASE_URL}/apis/v.1.0/capillary/get-fnb-banking-history/`,
	/** IDfy KYC (same paths as HMpower BST/api.js). */
	IDFY_CHECK_STATUS: `${BASE_URL}/apis/v.1.0/idfy/check-status/`,
	IDFY_CHECK_DOCUMENT: `${BASE_URL}/apis/v.1.0/idfy/check-document/`,
	IDFY_FACE_COMPARE_LIVE: `${BASE_URL}/apis/v.1.0/idfy/face-compare-live/`,
	SITE_BLOB_PRESIGNED_URL: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/site-blob-presigned-url/`,
	RENEW_SITE_BLOB_PRESIGNED_URL: `${BASE_URL}${API_VERSION}/site-leads/${APP_NAME}/renew-site-blob-presigned-url/`,
	MDP_MEETINGS_DETAILS: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/mdp-meetings`,
	ALL_RIGID_USER_API_RBDM: `${BASE_URL}${API_VERSION}/${APP_NAME}/rbdm-rigid-contractor/`,
	RIGID_CONTRACTOR_REQUEST: `${BASE_URL}${API_VERSION}/${APP_NAME}/rigid-contractor-request/`,
	RBDM_CMDI_USER_COUNT: `${BASE_URL}${API_VERSION}/meetings/${APP_NAME}/rbdm-cmdi-user-count/`,
};
